import { render, staticRenderFns } from "./AccGymSubscriptionDetail.vue?vue&type=template&id=28138fd0"
import script from "./AccGymSubscriptionDetail.vue?vue&type=script&lang=js"
export * from "./AccGymSubscriptionDetail.vue?vue&type=script&lang=js"
import style0 from "./AccGymSubscriptionDetail.vue?vue&type=style&index=0&id=28138fd0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports